<div
  class="node-socket"
  [class]="[nodeSocketType(), nodeTypeStyleClass(), index()]"
  [attr.data-testid]="'input-' + input().key">
  @if (showLabel()) {
    <span class="socket-name">{{ input()?.value?.label }}</span>
  }

  <div
    refComponent
    [class.input-socket]="nodeSocketType() === 'input'"
    [class.output-socket]="nodeSocketType() === 'output'"
    [data]="input() | socketData: data() : seed() : nodeSocketType()"
    [emit]="emit()"
    [attr.data-testid]="nodeSocketType() + '-socket-' + input().key"></div>
</div>
